import React, { useState, useEffect } from "react";
import { useI18n } from "../i18n";

/**
 * Floating WhatsApp button with bilingual pre-filled message.
 */
const WHATSAPP_NUMBER = "15614556277"; // +1 (561) 455-6277

const messages = {
  en: "Hi Movix! I'd like to rent a car. Could you help me?",
  pt: "Olá, Movix! Quero alugar um carro. Pode me ajudar?",
};

const WhatsAppButton = () => {
  const { lang } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const text = encodeURIComponent(messages[lang] || messages.en);
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-floating"
      className={`fixed z-40 bottom-6 right-6 flex items-center gap-3 bg-[#25D366] text-white pl-3 pr-5 py-3 rounded-full shadow-2xl hover:scale-105 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      style={{ boxShadow: "0 10px 30px -10px rgba(37, 211, 102, 0.6)" }}
    >
      <span className="bg-white/20 rounded-full p-2 flex items-center justify-center">
        <svg width="22" height="22" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 01-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 01-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.013.99.404 1.92.998 2.71 1.34 1.793 2.99 3.273 5.096 4.087.36.13.724.244 1.084.32.347.072.66.06.992.06.508 0 1.06-.13 1.464-.373.503-.302.79-.875.79-1.45 0-.226-.043-.487-.13-.673-.16-.31-.787-.475-1.087-.617z" />
          <path d="M16.002 0C7.16 0 .002 7.158.002 16c0 2.82.73 5.46 2.013 7.75L0 32l8.46-2.213A15.93 15.93 0 0016.002 32c8.842 0 16-7.158 16-16s-7.158-16-16-16zm0 29.333c-2.502 0-4.86-.7-6.857-1.91l-.49-.293-5.07 1.325 1.35-4.94-.32-.51A13.29 13.29 0 012.668 16C2.668 8.638 8.64 2.667 16.002 2.667c7.36 0 13.333 5.97 13.333 13.333 0 7.362-5.973 13.333-13.333 13.333z" />
        </svg>
      </span>
      <span className="text-sm font-medium hidden sm:inline" data-testid="whatsapp-label">
        WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
